<template>
	<div v-if="dataLoaded">
		<final-report-header-row
			:text="getHeader"
		/>


		<financial-table-types-top-header/>

		<financial-table-cost-headers
			:show-financial-table-cost-warnings="true"
			:values="{
				sumFromProject: fromProjectSum(),
				dotationFromProject: sumOfCostsFromTypesFromProject([FundingTypes.DOTATION]),
				otherFromProject: sumOfCostsFromTypesFromProject([FundingTypes.OTHER, FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE]),
				humanFromProject: sumOfCostsFromTypesFromProject([FundingTypes.OWN_HUMAN_CONTRIBUTION]),
				contributionFromProject: sumOfCostsFromTypesFromProject([FundingTypes.OWN_CONTRIBUTION_IN_KIND]),
				sumFromDocument: fromDocumentSum(),
				dotationFromDocument: sumOfCostsFromTypesFromDocument([FundingTypes.DOTATION]),
				otherFromDocument: sumOfCostsFromTypesFromDocument([FundingTypes.OTHER, FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE]),
				humanFromDocument: sumOfCostsFromTypesFromDocument([FundingTypes.OWN_HUMAN_CONTRIBUTION]),
				contributionFromDocument: sumOfCostsFromTypesFromDocument([FundingTypes.OWN_CONTRIBUTION_IN_KIND])
			}"/>

		<final-report-administrative-header/>

		<div v-for="(cost,index) in administrativeMerged.costs"
			:key="'administrativeMerged-' + cost.name + '-' + index">
			<v-flex d-flex xs12 style="page-break-inside: avoid">
				<v-card color='grey lighten-1' class="financial-table-header-color">
					<v-card-text class="financial-table-header-font-size">
						<strong>
							{{cost.serialNumber}} &emsp; {{cost.name}}
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>

			<financial-summary-large-row
				:text-right="true"
				first-cell-label=''
				:cells-formatter="formatMoney"
				:first-cell-color-intesity="2"
				:cells-color-intensity="2"
				:cells-values="[cost.fromProjectSum,
					fromDotationFromProject(cost),
					fromOtherFromProject(cost),
					fromOwnHumanFromProject(cost),
					fromOwnInKindFromProject(cost),
					cost.fromDocumentSum,
					fromDotationFromDocument(cost),
					fromOtherFromDocument(cost),
					fromOwnHumanFromDocument(cost),
					fromOwnInKindFromDocument(cost),
					fromInterestsFromDocument(cost)]"

			/>
		</div>

		<financial-summary-large-row
			class="financial-summary"
			:text-right="true"
			first-cell-label='Razem A'
			:cells-formatter="x => x"
			:first-cell-color-intesity="0"
			:cells-color-intensity="0"
			:cells-values="
				[
					formattedSumOfCostsFromTypesFromProject([FundingTypes.ALL], OmitModes.omitActions),
					formattedSumOfCostsFromTypesFromProject([FundingTypes.DOTATION], OmitModes.omitActions),
					formattedSumOfCostsFromTypesFromProject([FundingTypes.OTHER, FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE], OmitModes.omitActions),
					formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_HUMAN_CONTRIBUTION], OmitModes.omitActions),
					formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_CONTRIBUTION_IN_KIND], OmitModes.omitActions),
					formattedSumOfCostsFromTypesFromDocument([FundingTypes.ALL], OmitModes.omitActions),
					formattedSumOfCostsFromTypesFromDocument([FundingTypes.DOTATION], OmitModes.omitActions),
					formattedSumOfCostsFromTypesFromDocument([FundingTypes.OTHER, FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE], OmitModes.omitActions),
					formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_HUMAN_CONTRIBUTION], OmitModes.omitActions),
					formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_CONTRIBUTION_IN_KIND], OmitModes.omitActions),
					formattedSumOfCostsFromTypesFromDocument([FundingTypes.INCOME, FundingTypes.INTEREST], OmitModes.omitActions),
				]"

		/>


		<financial-report-costs-header/>

		<div v-for='(action, index) in costsMerged' :key="'costsMerged-' + index">
			<v-flex d-flex xs12 style="page-break-inside: avoid">
				<v-card color='grey' class="financial-table-header-color">
					<v-card-text class="financial-table-header-font-size">
						<strong>
							{{action.serialNumber}} &emsp; {{action.action}}
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<div v-for="(cost, costIndex) in action.costs.sort((a, b) => a.serialNumber - b.serialNumber)" :key="'actionCosts-' + cost.name + '-' + costIndex">
				<v-flex d-flex xs12 style="page-break-inside: avoid">
					<v-card color='grey lighten-1' class="financial-table-header-color">
						<v-card-text class="financial-table-header-font-size">
							<strong>
								{{action.serialNumber}}.{{cost.serialNumber}} &emsp;{{cost.name}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>

				<financial-summary-large-row
					:text-right="true"
					first-cell-label=''
					:cells-formatter="formatMoney"
					:first-cell-color-intesity="2"
					:cells-color-intensity="2"
					:cells-values="[cost.fromProjectSum,
						fromDotationFromProject(cost),
						fromOtherFromProject(cost),
						fromOwnHumanFromProject(cost),
						fromOwnInKindFromProject(cost),
						cost.fromDocumentSum,
						fromDotationFromDocument(cost),
						fromOtherFromDocument(cost),
						fromOwnHumanFromDocument(cost),
						fromOwnInKindFromDocument(cost),
						fromInterestsFromDocument(cost)]"

				/>
			</div>

			<financial-summary-large-row
				class="financial-summary"
				:text-right="true"
				first-cell-label='Razem'
				:cells-formatter="formatMoney"
				:first-cell-color-intesity="1"
				:cells-color-intensity="1"
				:cells-values="[
					action.fromProjectSumTotal,
					sumOfCostsFromTypesFromSingleAction(action, fromDotationFromProject),
					sumOfCostsFromTypesFromSingleAction(action, fromOtherFromProject),
					sumOfCostsFromTypesFromSingleAction(action, fromOwnHumanFromProject),
					sumOfCostsFromTypesFromSingleAction(action, fromOwnInKindFromProject),
					action.fromDocumentSumTotal,
					sumOfCostsFromTypesFromSingleAction(action, fromDotationFromDocument),
					sumOfCostsFromTypesFromSingleAction(action, fromOtherFromDocument),
					sumOfCostsFromTypesFromSingleAction(action, fromOwnHumanFromDocument),
					sumOfCostsFromTypesFromSingleAction(action, fromOwnInKindFromDocument),
					sumOfCostsFromTypesFromSingleAction(action, fromInterestsFromDocument),
				]"

			/>

		</div>

		<financial-summary-large-row
			class="financial-summary"
			:text-right="true"
			first-cell-label='Razem P'
			:cells-formatter="x => x"
			:first-cell-color-intesity='0'
			:cells-color-intensity="0"
			:cells-values="[
				formattedSumOfCostsFromTypesFromProject([FundingTypes.ALL], OmitModes.omitAdministrative),
				formattedSumOfCostsFromTypesFromProject([FundingTypes.DOTATION], OmitModes.omitAdministrative),
				formattedSumOfCostsFromTypesFromProject([FundingTypes.OTHER, FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE], OmitModes.omitAdministrative),
				formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_HUMAN_CONTRIBUTION], OmitModes.omitAdministrative),
				formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_CONTRIBUTION_IN_KIND], OmitModes.omitAdministrative),
				formattedSumOfCostsFromTypesFromDocument([FundingTypes.ALL], OmitModes.omitAdministrative),
				formattedSumOfCostsFromTypesFromDocument([FundingTypes.DOTATION], OmitModes.omitAdministrative),
				formattedSumOfCostsFromTypesFromDocument([FundingTypes.OTHER, FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE], OmitModes.omitAdministrative),
				formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_HUMAN_CONTRIBUTION], OmitModes.omitAdministrative),
				formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_CONTRIBUTION_IN_KIND], OmitModes.omitAdministrative),
				formattedSumOfCostsFromTypesFromDocument([FundingTypes.INCOME, FundingTypes.INTEREST], OmitModes.omitAdministrative),
			]"

		/>

		<financial-summary-large-row
			class="financial-summary"
			:text-right="true"
			first-cell-label='Razem A+P'
			:cells-formatter="x => x"
			:first-cell-color-intesity="-1"
			:cells-color-intensity="-1"
			:cells-values="[
				fromProjectSumFormatted(),
				formattedSumOfCostsFromTypesFromProject([FundingTypes.DOTATION]),
				formattedSumOfCostsFromTypesFromProject([FundingTypes.OTHER, FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE]),
				formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_HUMAN_CONTRIBUTION]),
				formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_CONTRIBUTION_IN_KIND]),
				fromDocumentSumFormatted(),
				formattedSumOfCostsFromTypesFromDocument([FundingTypes.DOTATION]),
				formattedSumOfCostsFromTypesFromDocument([FundingTypes.OTHER, FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE]),
				formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_HUMAN_CONTRIBUTION]),
				formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_CONTRIBUTION_IN_KIND]),
				formattedSumOfCostsFromTypesFromDocument([FundingTypes.INCOME, FundingTypes.INTEREST]),
			]"

		/>

		<div class="mt-5 mb-5 financial-table-header-font-size">
			<final-report-header-row
				text="2. Rozliczenie ze względu na źródło finansowania"
			/>
			<final-report-data-row
				text1="Lp."
				text2="Źródło finansowania"
				text3="Koszty zgodnie z umową (w zł)"
				text4="Faktycznie poniesione wydatki (w zł)"

				:colors="[0, 1, 1, 1]"
			/>

			<financial-summary-row
				:index="1"
				label="Dotacja, w tym odsetki bankowe od dotacji oraz inne przychody ogółem"
				:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.DOTATION, FundingTypes.INTEREST, FundingTypes.INCOME])"
				:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.DOTATION, FundingTypes.INTEREST, FundingTypes.INCOME])"
			/>
			<financial-summary-sub-row
				:index="1.1"
				label="Z dotacji"
				:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.DOTATION])"
				:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.DOTATION])"
			/>
			<financial-summary-sub-row
				:index="1.2"
				label="Odsetki bankowe od dotacji"
				:document-only="true"
				:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.INTEREST])"
			/>
			<financial-summary-sub-row
				:index="1.3"
				label="Inne przychody"
				:document-only="true"
				:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.INCOME])"
			/>

			<financial-summary-row
				:index="2"
				label="Inne środki finansowe ogółem"
				:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER])"
				:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER])"
			/>
			<financial-summary-sub-row
				:index="2.1"
				label="Środki finansowe własne"
				:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_FINANCIAL_CONTRIBUTION])"
				:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_FINANCIAL_CONTRIBUTION])"
			/>
			<financial-summary-sub-row
				:index="2.2"
				label="Świadczenia pieniężne od odbiorców"
				:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.MONEY_FROM_RECIPIENTS])"
				:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.MONEY_FROM_RECIPIENTS])"
			/>
			<financial-summary-sub-row
				:index="2.3"
				label="Środki finansowe z innych źródeł publicznych"
				:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.OTHER_PUBLIC_SOURCE])"
				:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.OTHER_PUBLIC_SOURCE])"
			/>
			<financial-summary-sub-row
				:index="2.4"
				label="Pozostałe"
				:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.OTHER])"
				:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.OTHER])"
			/>
			<financial-summary-row
				:index="3"
				label="Wkład osobowy i rzeczowy ogółem"
				:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_HUMAN_CONTRIBUTION, FundingTypes.OWN_CONTRIBUTION_IN_KIND])"
				:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_HUMAN_CONTRIBUTION, FundingTypes.OWN_CONTRIBUTION_IN_KIND])"
			/>
			<financial-summary-sub-row
				:index="3.1"
				label="Wkład osobowy"
				:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_HUMAN_CONTRIBUTION])"
				:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_HUMAN_CONTRIBUTION])"
			/>
			<financial-summary-sub-row
				:index="3.2"
				label="Wkład rzeczowy"
				:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_CONTRIBUTION_IN_KIND])"
				:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_CONTRIBUTION_IN_KIND])"
			/>
			<financial-summary-row
				:index="4"
				label="Ogółem"
				:from-document="formattedSumOfCostsFromTypesFromDocument([FundingTypes.ALL])"
				:from-project="formattedSumOfCostsFromTypesFromProject([FundingTypes.ALL])"
			/>
			<financial-summary-row
				:is-percentage="true"
				:index="5"
				label="Udział wkładu własnego w stosunku do kwoty dotacji"
				:compare="'ge'"
				:from-document="percentSumOfCostsToDotationFromDocument([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER, FundingTypes.OWN_HUMAN_CONTRIBUTION, FundingTypes.OWN_CONTRIBUTION_IN_KIND])"
				:from-project="percentSumOfCostsToDotationFromProject([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER, FundingTypes.OWN_HUMAN_CONTRIBUTION, FundingTypes.OWN_CONTRIBUTION_IN_KIND])"
			/>
			<financial-summary-row
				:is-percentage="true"
				:index="6"
				label="Udział kwoty dotacji w całkowitych kosztach"
				:compare="'le'"
				:from-document="percentDotationFromDocumentFormatted()"
				:from-project="percentDotationFromProjectFormatted()"
			/>
			<financial-summary-row
				:is-percentage="true"
				:index="7"
				label="Udział innych środków finansowych w stosunku do kwoty dotacji"
				:compare="'ge'"
				:from-document="percentSumOfCostsToDotationFromDocument([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER])"
				:from-project="percentSumOfCostsToDotationFromProject([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER])"
			/>

			<financial-summary-row
				:is-percentage="true"
				:index="8"
				label="Udział wkładu osobowego i wkładu rzeczowego w stosunku do kwoty dotacji"
				:compare="'ge'"
				:from-document="percentSumOfCostsToDotationFromDocument([FundingTypes.OWN_CONTRIBUTION_IN_KIND, FundingTypes.OWN_HUMAN_CONTRIBUTION])"
				:from-project="percentSumOfCostsToDotationFromProject([FundingTypes.OWN_CONTRIBUTION_IN_KIND, FundingTypes.OWN_HUMAN_CONTRIBUTION])"
			/>
		</div>
	</div>
</template>

<script>
	import FinancialSummaryRow from "./FinancialSummaryRow";
	import FinalReportDataRow from "./FinalReportDataRow";
	import FinalReportHeaderRow from "./FinalReportHeaderRow";
	import {Numbers} from "../../../utils/Numbers";
	import FinancialSummaryLargeRow from "./FinancialSummaryLargeRow";
	import FinancialTableTypesTopHeader from "./FinancialTableTypesTopHeader";
	import FinalReportAdministrativeHeader from "./FinalReportAdministrativeHeader";
	import FinancialReportCostsHeader from "./FinancialReportCostsHeader";
	import FinancialTableCostHeaders from "./FinancialTableCostHeaders";
	import FinancialSummarySubRow from "./FinancialSummarySubRow";
	import {FinalReportCostsUtils} from "./Utils/FinalReportCostsUtils";
	import {FundingTypes} from "./Utils/FinalReportFundingTypes";
	import {OmitModes} from "./Utils/OmitModes";
	import {FinalReportCostExported} from "./Utils/FinalReportCostExporter";

	export default {
		name: "FinalReportFinancialTable",
		components: {
			FinancialTableCostHeaders,
			FinancialReportCostsHeader,
			FinalReportAdministrativeHeader,
			FinancialTableTypesTopHeader,
			FinancialSummaryLargeRow,
			FinalReportHeaderRow, FinalReportDataRow, FinancialSummaryRow, FinancialSummarySubRow,
		},

		props: {
			projectData: {},
			invoicesData: {},
		},

		mixins: [Numbers, FinalReportCostsUtils],

		data() {
			return {
				//żeby dało się ich używać w <template>
				OmitModes: OmitModes,
				//żeby dało się ich używać w <template>
				FundingTypes: FundingTypes,

				loaded: false,
				projectId: this.$route.params.projectId,
			};
		},

		methods: {
			generateExport () {
				return FinalReportCostExported.generate(this);
			},
		},

		computed: {
			dataLoaded() {
				return this.projectData && this.invoicesData;
			},

			costsMerged: {
				cache: false,
				get: function () {
					if (!this.dataLoaded) {
						return [];
					}
					return this.calculateCostsMerged();
				}
			},

			administrativeMerged: {
				cache: false,
				get: function () {
					if (!this.dataLoaded) {
						return [];
					}
					return this.calculateAdministrativeMerged();
				}
			},

			getHeader () {
				let header = "1. Rozliczenie wydatków";
				if (this.projectData.projectYear !== null) {
					header = header + " w roku " + this.projectData.projectYear;
				}
				return header;
			}
		}
	};
</script>
<style>
	.financial-summary .financial-summary-first-cell strong {
		font-size: 13px;
	}
</style>
